import React, { useEffect, useState } from "react";
import { getValue } from "@utils/lodash";
import { formatDecimal } from "@_common/text-helpers";
import { Table } from "reactstrap";
import "@components/Dashboard/ExpandableTable/ExpandableTable.scss";

interface ExpandableTableProps {
	locations: Record<string, string>[];
	handleClickRow: (locationId: string) => void;
	functions: Record<string, string>[];
	headers: any | [];
	child_loading: boolean;
}

const LicenseExpandableTable: React.FunctionComponent<ExpandableTableProps> = (
	props
) => {
	const { locations, functions, headers, child_loading } = props;
	const [locationIndex, setLocationIndex] = useState<number | null>(null);

	return (
		<div className="location-wise-table-card">
			<Table>
				<thead>
					<th></th>
					{headers.map((item: any) => (
						<th>{item}</th>
					))}
				</thead>
				<tbody className="location-wise-wrapper__overflow">
					{locations.length > 0 ? (
						locations.map((item, index) => {
							return (
								<>
									<tr
										key={index}
										className={`${
											locationIndex === index
												? "location-wise-table-card__active-row"
												: ""
										}`}
										onClick={() =>
											props.handleClickRow(
												index !== locationIndex ? getValue(item, `id`, "") : ""
											)
										}
									>
										<td
											onClick={() => {
												setLocationIndex(
													index === locationIndex ? null : index
												);
											}}
											className="cursor-pointer"
										>
											<img
												src={`/images/dashboard/tables/${
													locationIndex === index
														? "remove-circle"
														: "add-circle"
												}.svg`}
											/>
										</td>
										<td>{getValue(item, `location`, "")}</td>
										<td>
											{getValue(item, `auditData.expired_license.count`, "")}
										</td>
										<td>
											{getValue(item, `auditData.valid_license.count`, "")}
										</td>
										<td>
											{getValue(item, `auditData.upcoming_license.count`, "")}
										</td>
										<td>{getValue(item, `auditData.total.count`, "")}</td>
									</tr>
									{
										locationIndex === index && child_loading ? (
											<tr>
												<td></td>
												<td></td>
												<td></td>
												<td></td>
												<td>Please wait...</td>
												<td></td>
												<td></td>
												<td></td>
											</tr>
										) : (
											locationIndex === index &&
											functions.length > 0 &&
											functions.map((items, index) => {
												return (
													<tr className="location-wise-table-card__sub-table-info">
														<td
															onClick={() => {
																setLocationIndex(index);
															}}
															className="cursor-pointer"
														>
															{/* <img
																src={`/images/dashboard/tables/${
																	locationIndex === index
																		? "remove-circle"
																		: "add-circle"
																}.svg`}
															/> */}
														</td>
														<td>{getValue(items, `location`, "")}</td>
														<td>
															{getValue(
																items,
																`auditData.expired_license.count`,
																""
															)}
														</td>
														<td>
															{getValue(
																items,
																`auditData.valid_license.count`,
																""
															)}
														</td>
														<td>
															{getValue(
																items,
																`auditData.upcoming_license.count`,
																""
															)}
														</td>
														<td>
															{getValue(items, `auditData.total.count`, "")}
														</td>
													</tr>
												);
											})
										)
										// ) : (
										// 	<tr>
										// 		<td></td>
										// 		<td></td>
										// 		<td></td>
										// 		<td></td>
										// 		<td>No Data Found</td>
										// 		<td></td>
										// 		<td></td>
										// 		<td></td>
										// 	</tr>
										// )
									}
								</>
							);
						})
					) : (
						<tr>
							<td colSpan={6} className="text-center">No Data Found</td>
						</tr>
					)}
				</tbody>
			</Table>
		</div>
	);
};

export default LicenseExpandableTable;
